export enum Page {
  Monitor = "/monitor",
  Simulate = "/",
  Alerts = "/alerts",
  Admin = "/admin",
  Mdf = "/mdf",
}
